import { render, staticRenderFns } from "./carouselNew.vue?vue&type=template&id=6da821cf&scoped=true"
import script from "./carouselNew.vue?vue&type=script&lang=js"
export * from "./carouselNew.vue?vue&type=script&lang=js"
import style0 from "./carouselNew.vue?vue&type=style&index=0&id=6da821cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da821cf",
  null
  
)

export default component.exports